import { HiOutlineChevronRight, HiOutlineHome } from "react-icons/hi2";
import { cn } from "../../../lib/cn";

export const FolderBreadcrumbs = ({ breadcrumbs = [], onNavigate }) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Folder breadcrumb" className="flex flex-wrap items-center gap-1 text-sm">
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const isRoot = crumb.is_root;
        return (
          <span key={crumb.id} className="flex items-center gap-1">
            {index > 0 && (
              <HiOutlineChevronRight className="w-3.5 h-3.5 text-grey" aria-hidden="true" />
            )}
            {isLast ? (
              <span
                aria-current="page"
                className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 font-semibold text-darkgrey"
              >
                {isRoot && <HiOutlineHome className="w-4 h-4 text-secondary-dark" aria-hidden="true" />}
                {crumb.name}
              </span>
            ) : (
              <button
                type="button"
                onClick={() => onNavigate?.(crumb.id)}
                className={cn(
                  "inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-grey transition-colors hover:bg-surface-hover hover:text-darkgrey",
                  isRoot && "text-darkgrey"
                )}
              >
                {isRoot && <HiOutlineHome className="w-4 h-4 text-secondary-dark" aria-hidden="true" />}
                {crumb.name}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
};
